"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/select/style");
var _select = _interopRequireDefault(require("antd/lib/select"));
var _ahooks = require("ahooks");
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var Option = _select.default.Option;

// Adapted from https://3x.ant.design/components/select/#components-select-demo-select-users
var SearchItems = function SearchItems(_ref) {
  var getSearchUrl = _ref.getSearchUrl,
    renderItem = _ref.renderItem,
    placeholder = _ref.placeholder,
    value = _ref.value,
    onChange = _ref.onChange;
  // For fetch callback order
  var lastFetchId = (0, _react.useRef)(0);
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    fetching = _useState4[0],
    setFetching = _useState4[1];
  var _useDebounceFn = (0, _ahooks.useDebounceFn)( /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
        var fetchId, response, items;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (query) {
                  _context.next = 3;
                  break;
                }
                setItems([]);
                return _context.abrupt("return");
              case 3:
                lastFetchId.current += 1;
                fetchId = lastFetchId.current;
                setItems([]);
                setFetching(true);
                _context.next = 9;
                return _utils.api.get(getSearchUrl({
                  query: query
                }));
              case 9:
                response = _context.sent;
                if (!(fetchId !== lastFetchId.current)) {
                  _context.next = 12;
                  break;
                }
                return _context.abrupt("return");
              case 12:
                items = response.data.map(function (item) {
                  return {
                    text: renderItem(item),
                    value: item.id
                  };
                });
                setItems(items);
                setFetching(false);
              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), {
      wait: 500
    }),
    handleSearch = _useDebounceFn.run;
  var handleChange = function handleChange(value) {
    onChange(value);
    setItems([]);
    setFetching(false);
  };
  return /*#__PURE__*/_react.default.createElement(_select.default, {
    mode: "multiple",
    value: value,
    placeholder: placeholder,
    notFoundContent: fetching ? /*#__PURE__*/_react.default.createElement(_spin.default, {
      size: "small"
    }) : null,
    filterOption: false,
    onSearch: handleSearch,
    onChange: handleChange,
    labelInValue: true
  }, items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(Option, {
      key: item.value
    }, item.text);
  }));
};
var _default = SearchItems;
exports.default = _default;